/** @format */

import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import Home from "../views/Home.vue";
import Dashboard from "../views/Dashboard.vue";
import RegisterUser from "../views/RegisterUser.vue";
import LoginUser from "../views/LoginUser.vue";
import Rounds from "../views/Rounds.vue";
import Statistics from "../views/Statistics.vue";
import ShotAnalysis from "../views/ShotAnalysis.vue";
import RoundsEdit from "../views/RoundsEdit.vue";
import Courses from "../views/Courses.vue";
import CoursesEdit from "../views/CoursesEdit.vue";
import NotFound from "../views/NotFound.vue";
import NetworkIssue from "../views/NetworkIssue.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home
	},
	{
		path: "/dashboard",
		name: "Dashboard",
		component: Dashboard,
		meta: { requiresAuth: true }
	},
	{
		path: "/courses",
		name: "Courses",
		component: Courses,
		meta: { requiresAuth: true }
	},
	{
		path: "/courses/:courseUuid",
		name: "CoursesEdit",
		component: CoursesEdit,
		meta: { requiresAuth: true },
		props: true,
		beforeEnter(routeTo, routeFrom, next) {
			store
				.dispatch("courses/getCourse", routeTo.params.courseUuid)
				.then(({ data }) => {
					routeTo.params.golfCourse = data.data;
					next();
				})
				.catch(error => {
					if (error.response && error.response.status == "404") {
						next({ name: "404", params: { resource: "event" } });
					} else {
						next({ name: "network-issue" });
					}
				});
		}
	},
	{
		path: "/rounds/:roundUuid",
		name: "RoundsEdit",
		component: RoundsEdit,
		meta: { requiresAuth: true },
		props: true,
		beforeEnter(routeTo, routeFrom, next) {
			store
				.dispatch("rounds/getRound", routeTo.params.roundUuid)
				.then(({ data }) => {
					routeTo.params.golfRound = data.data;
					next();
				})
				.catch(error => {
					if (error.response && error.response.status == "404") {
						next({ name: "404", params: { resource: "round" } });
					} else {
						next({ name: "network-issue" });
					}
				});
		}
	},
	{
		path: "/rounds",
		name: "Rounds",
		component: Rounds,
		meta: { requiresAuth: true }
	},
	{
		path: "/statistics",
		name: "Statistics",
		component: Statistics,
		meta: { requiresAuth: true },
		props: true,
		beforeEnter(routeTo, routeFrom, next) {
			store
				.dispatch("rounds/getStatsRounds")
				.then(({ data }) => {
					routeTo.params.golfRounds = data.data;
					next();
				})
				.catch(error => {
					if (error.response && error.response.status == "404") {
						next({ name: "404", params: { resource: "round" } });
					} else {
						next({ name: "network-issue" });
					}
				});
		}
	},
	{
		path: "/shot-analysis",
		name: "Shot Analysis",
		component: ShotAnalysis,
		meta: { requiresAuth: true },
		props: true,
		beforeEnter(routeTo, routeFrom, next) {
			store
				.dispatch("rounds/getShotAnalysis")
				.then(({ data }) => {
					routeTo.params.shotAnalysis = data;
					next();
				})
				.catch(error => {
					if (error.response && error.response.status == "404") {
						next({ name: "404", params: { resource: "round" } });
					} else {
						next({ name: "network-issue" });
					}
				});
		}
	},
	{
		path: "/register",
		name: "RegisterUser",
		component: RegisterUser
	},
	{
		path: "/login",
		name: "LoginUser",
		component: LoginUser
	},
	{
		path: "/404",
		name: "404",
		props: true,
		component: NotFound
	},
	{
		path: "/network-issue",
		name: "network-issue",
		props: true,
		component: NetworkIssue
	},
	{
		path: "*",
		redirect: { name: "404", params: { resource: "page" } }
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

router.beforeEach((to, from, next) => {
	const loggedIn = localStorage.getItem("user");
	NProgress.start();
	if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
		store.dispatch("notification/add", {
			type: "error",
			message: "Sorry, you are not logged in"
		});
		next("/");
	} else {
		next(); // make sure to always call next()!
	}
});

router.afterEach((to, from) => {
	NProgress.done();
});
export default router;
